/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedRelatorioRouteRouteImport } from './routes/_authenticated/relatorio/route'
import { Route as AuthenticatedMovimentacaoRouteRouteImport } from './routes/_authenticated/movimentacao/route'
import { Route as AuthenticatedEstoqueRouteRouteImport } from './routes/_authenticated/estoque/route'
import { Route as AuthenticatedConsultaRouteRouteImport } from './routes/_authenticated/consulta/route'
import { Route as AuthenticatedConfiguracaoRouteRouteImport } from './routes/_authenticated/configuracao/route'
import { Route as AuthenticatedHomeIndexRouteImport } from './routes/_authenticated/home/index'
import { Route as AuthenticatedRelatorioMapaProducaoExpedicaoIndexRouteImport } from './routes/_authenticated/relatorio/mapa-producao-expedicao/index'
import { Route as AuthenticatedRelatorioHistoricosIntegracaoIndexRouteImport } from './routes/_authenticated/relatorio/historicos-integracao/index'
import { Route as AuthenticatedRelatorioGiroEstoqueIndexRouteImport } from './routes/_authenticated/relatorio/giro-estoque/index'
import { Route as AuthenticatedRelatorioEtiquetasIndexRouteImport } from './routes/_authenticated/relatorio/etiquetas/index'
import { Route as AuthenticatedRelatorioCurvaAbcIndexRouteImport } from './routes/_authenticated/relatorio/curva-abc/index'
import { Route as AuthenticatedMovimentacaoLeituraPedidoIndexRouteImport } from './routes/_authenticated/movimentacao/leitura-pedido/index'
import { Route as AuthenticatedMovimentacaoEntradaProdutoIndexRouteImport } from './routes/_authenticated/movimentacao/entrada-produto/index'
import { Route as AuthenticatedMovimentacaoEnderecamentoIndexRouteImport } from './routes/_authenticated/movimentacao/enderecamento/index'
import { Route as AuthenticatedMovimentacaoConferenciaXmlIndexRouteImport } from './routes/_authenticated/movimentacao/conferencia-xml/index'
import { Route as AuthenticatedMovimentacaoColetaPesosIndexRouteImport } from './routes/_authenticated/movimentacao/coleta-pesos/index'
import { Route as AuthenticatedEstoqueVisualizacaoEstoqueIndexRouteImport } from './routes/_authenticated/estoque/visualizacao-estoque/index'
import { Route as AuthenticatedEstoqueRelatorioEstoqueIndexRouteImport } from './routes/_authenticated/estoque/relatorio-estoque/index'
import { Route as AuthenticatedEstoqueControleEstoqueIndexRouteImport } from './routes/_authenticated/estoque/controle-estoque/index'
import { Route as AuthenticatedConsultaEtiquetasIndexRouteImport } from './routes/_authenticated/consulta/etiquetas/index'
import { Route as AuthenticatedConfiguracaoVarejoIndexRouteImport } from './routes/_authenticated/configuracao/varejo/index'
import { Route as AuthenticatedConfiguracaoProdutosIndexRouteImport } from './routes/_authenticated/configuracao/produtos/index'
import { Route as AuthenticatedConfiguracaoModelosEtiquetaIndexRouteImport } from './routes/_authenticated/configuracao/modelos-etiqueta/index'
import { Route as AuthenticatedConfiguracaoModelosBarcodeIndexRouteImport } from './routes/_authenticated/configuracao/modelos-barcode/index'
import { Route as AuthenticatedConfiguracaoIntegracoesIndexRouteImport } from './routes/_authenticated/configuracao/integracoes/index'
import { Route as AuthenticatedConfiguracaoImpressorasIndexRouteImport } from './routes/_authenticated/configuracao/impressoras/index'
import { Route as AuthenticatedConfiguracaoEstoqueFisicoIndexRouteImport } from './routes/_authenticated/configuracao/estoque-fisico/index'
import { Route as AuthenticatedConfiguracaoConfigBalancaIndexRouteImport } from './routes/_authenticated/configuracao/config-balanca/index'
import { Route as AuthenticatedConfiguracaoCatalogoProdutoIndexRouteImport } from './routes/_authenticated/configuracao/catalogo-produto/index'
import { Route as AuthenticatedRelatorioMapaProducaoExpedicaoFormRouteImport } from './routes/_authenticated/relatorio/mapa-producao-expedicao/form'
import { Route as AuthenticatedRelatorioGiroEstoqueFormRouteImport } from './routes/_authenticated/relatorio/giro-estoque/form'
import { Route as AuthenticatedRelatorioEtiquetasFormRouteImport } from './routes/_authenticated/relatorio/etiquetas/form'
import { Route as AuthenticatedRelatorioCurvaAbcFormRouteImport } from './routes/_authenticated/relatorio/curva-abc/form'
import { Route as AuthenticatedConfiguracaoModelosEtiquetaFormRouteImport } from './routes/_authenticated/configuracao/modelos-etiqueta/form'
import { Route as AuthenticatedConfiguracaoModelosEtiquetaFormIndexRouteImport } from './routes/_authenticated/configuracao/modelos-etiqueta/form.index'
import { Route as AuthenticatedConfiguracaoModelosEtiquetaFormIdRouteImport } from './routes/_authenticated/configuracao/modelos-etiqueta/form.$id'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRelatorioRouteRoute =
  AuthenticatedRelatorioRouteRouteImport.update({
    id: '/relatorio',
    path: '/relatorio',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMovimentacaoRouteRoute =
  AuthenticatedMovimentacaoRouteRouteImport.update({
    id: '/movimentacao',
    path: '/movimentacao',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEstoqueRouteRoute =
  AuthenticatedEstoqueRouteRouteImport.update({
    id: '/estoque',
    path: '/estoque',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConsultaRouteRoute =
  AuthenticatedConsultaRouteRouteImport.update({
    id: '/consulta',
    path: '/consulta',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConfiguracaoRouteRoute =
  AuthenticatedConfiguracaoRouteRouteImport.update({
    id: '/configuracao',
    path: '/configuracao',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeIndexRoute = AuthenticatedHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRelatorioMapaProducaoExpedicaoIndexRoute =
  AuthenticatedRelatorioMapaProducaoExpedicaoIndexRouteImport.update({
    id: '/mapa-producao-expedicao/',
    path: '/mapa-producao-expedicao/',
    getParentRoute: () => AuthenticatedRelatorioRouteRoute,
  } as any)
const AuthenticatedRelatorioHistoricosIntegracaoIndexRoute =
  AuthenticatedRelatorioHistoricosIntegracaoIndexRouteImport.update({
    id: '/historicos-integracao/',
    path: '/historicos-integracao/',
    getParentRoute: () => AuthenticatedRelatorioRouteRoute,
  } as any)
const AuthenticatedRelatorioGiroEstoqueIndexRoute =
  AuthenticatedRelatorioGiroEstoqueIndexRouteImport.update({
    id: '/giro-estoque/',
    path: '/giro-estoque/',
    getParentRoute: () => AuthenticatedRelatorioRouteRoute,
  } as any)
const AuthenticatedRelatorioEtiquetasIndexRoute =
  AuthenticatedRelatorioEtiquetasIndexRouteImport.update({
    id: '/etiquetas/',
    path: '/etiquetas/',
    getParentRoute: () => AuthenticatedRelatorioRouteRoute,
  } as any)
const AuthenticatedRelatorioCurvaAbcIndexRoute =
  AuthenticatedRelatorioCurvaAbcIndexRouteImport.update({
    id: '/curva-abc/',
    path: '/curva-abc/',
    getParentRoute: () => AuthenticatedRelatorioRouteRoute,
  } as any)
const AuthenticatedMovimentacaoLeituraPedidoIndexRoute =
  AuthenticatedMovimentacaoLeituraPedidoIndexRouteImport.update({
    id: '/leitura-pedido/',
    path: '/leitura-pedido/',
    getParentRoute: () => AuthenticatedMovimentacaoRouteRoute,
  } as any)
const AuthenticatedMovimentacaoEntradaProdutoIndexRoute =
  AuthenticatedMovimentacaoEntradaProdutoIndexRouteImport.update({
    id: '/entrada-produto/',
    path: '/entrada-produto/',
    getParentRoute: () => AuthenticatedMovimentacaoRouteRoute,
  } as any)
const AuthenticatedMovimentacaoEnderecamentoIndexRoute =
  AuthenticatedMovimentacaoEnderecamentoIndexRouteImport.update({
    id: '/enderecamento/',
    path: '/enderecamento/',
    getParentRoute: () => AuthenticatedMovimentacaoRouteRoute,
  } as any)
const AuthenticatedMovimentacaoConferenciaXmlIndexRoute =
  AuthenticatedMovimentacaoConferenciaXmlIndexRouteImport.update({
    id: '/conferencia-xml/',
    path: '/conferencia-xml/',
    getParentRoute: () => AuthenticatedMovimentacaoRouteRoute,
  } as any)
const AuthenticatedMovimentacaoColetaPesosIndexRoute =
  AuthenticatedMovimentacaoColetaPesosIndexRouteImport.update({
    id: '/coleta-pesos/',
    path: '/coleta-pesos/',
    getParentRoute: () => AuthenticatedMovimentacaoRouteRoute,
  } as any)
const AuthenticatedEstoqueVisualizacaoEstoqueIndexRoute =
  AuthenticatedEstoqueVisualizacaoEstoqueIndexRouteImport.update({
    id: '/visualizacao-estoque/',
    path: '/visualizacao-estoque/',
    getParentRoute: () => AuthenticatedEstoqueRouteRoute,
  } as any)
const AuthenticatedEstoqueRelatorioEstoqueIndexRoute =
  AuthenticatedEstoqueRelatorioEstoqueIndexRouteImport.update({
    id: '/relatorio-estoque/',
    path: '/relatorio-estoque/',
    getParentRoute: () => AuthenticatedEstoqueRouteRoute,
  } as any)
const AuthenticatedEstoqueControleEstoqueIndexRoute =
  AuthenticatedEstoqueControleEstoqueIndexRouteImport.update({
    id: '/controle-estoque/',
    path: '/controle-estoque/',
    getParentRoute: () => AuthenticatedEstoqueRouteRoute,
  } as any)
const AuthenticatedConsultaEtiquetasIndexRoute =
  AuthenticatedConsultaEtiquetasIndexRouteImport.update({
    id: '/etiquetas/',
    path: '/etiquetas/',
    getParentRoute: () => AuthenticatedConsultaRouteRoute,
  } as any)
const AuthenticatedConfiguracaoVarejoIndexRoute =
  AuthenticatedConfiguracaoVarejoIndexRouteImport.update({
    id: '/varejo/',
    path: '/varejo/',
    getParentRoute: () => AuthenticatedConfiguracaoRouteRoute,
  } as any)
const AuthenticatedConfiguracaoProdutosIndexRoute =
  AuthenticatedConfiguracaoProdutosIndexRouteImport.update({
    id: '/produtos/',
    path: '/produtos/',
    getParentRoute: () => AuthenticatedConfiguracaoRouteRoute,
  } as any)
const AuthenticatedConfiguracaoModelosEtiquetaIndexRoute =
  AuthenticatedConfiguracaoModelosEtiquetaIndexRouteImport.update({
    id: '/modelos-etiqueta/',
    path: '/modelos-etiqueta/',
    getParentRoute: () => AuthenticatedConfiguracaoRouteRoute,
  } as any)
const AuthenticatedConfiguracaoModelosBarcodeIndexRoute =
  AuthenticatedConfiguracaoModelosBarcodeIndexRouteImport.update({
    id: '/modelos-barcode/',
    path: '/modelos-barcode/',
    getParentRoute: () => AuthenticatedConfiguracaoRouteRoute,
  } as any)
const AuthenticatedConfiguracaoIntegracoesIndexRoute =
  AuthenticatedConfiguracaoIntegracoesIndexRouteImport.update({
    id: '/integracoes/',
    path: '/integracoes/',
    getParentRoute: () => AuthenticatedConfiguracaoRouteRoute,
  } as any)
const AuthenticatedConfiguracaoImpressorasIndexRoute =
  AuthenticatedConfiguracaoImpressorasIndexRouteImport.update({
    id: '/impressoras/',
    path: '/impressoras/',
    getParentRoute: () => AuthenticatedConfiguracaoRouteRoute,
  } as any)
const AuthenticatedConfiguracaoEstoqueFisicoIndexRoute =
  AuthenticatedConfiguracaoEstoqueFisicoIndexRouteImport.update({
    id: '/estoque-fisico/',
    path: '/estoque-fisico/',
    getParentRoute: () => AuthenticatedConfiguracaoRouteRoute,
  } as any)
const AuthenticatedConfiguracaoConfigBalancaIndexRoute =
  AuthenticatedConfiguracaoConfigBalancaIndexRouteImport.update({
    id: '/config-balanca/',
    path: '/config-balanca/',
    getParentRoute: () => AuthenticatedConfiguracaoRouteRoute,
  } as any)
const AuthenticatedConfiguracaoCatalogoProdutoIndexRoute =
  AuthenticatedConfiguracaoCatalogoProdutoIndexRouteImport.update({
    id: '/catalogo-produto/',
    path: '/catalogo-produto/',
    getParentRoute: () => AuthenticatedConfiguracaoRouteRoute,
  } as any)
const AuthenticatedRelatorioMapaProducaoExpedicaoFormRoute =
  AuthenticatedRelatorioMapaProducaoExpedicaoFormRouteImport.update({
    id: '/mapa-producao-expedicao/form',
    path: '/mapa-producao-expedicao/form',
    getParentRoute: () => AuthenticatedRelatorioRouteRoute,
  } as any)
const AuthenticatedRelatorioGiroEstoqueFormRoute =
  AuthenticatedRelatorioGiroEstoqueFormRouteImport.update({
    id: '/giro-estoque/form',
    path: '/giro-estoque/form',
    getParentRoute: () => AuthenticatedRelatorioRouteRoute,
  } as any)
const AuthenticatedRelatorioEtiquetasFormRoute =
  AuthenticatedRelatorioEtiquetasFormRouteImport.update({
    id: '/etiquetas/form',
    path: '/etiquetas/form',
    getParentRoute: () => AuthenticatedRelatorioRouteRoute,
  } as any)
const AuthenticatedRelatorioCurvaAbcFormRoute =
  AuthenticatedRelatorioCurvaAbcFormRouteImport.update({
    id: '/curva-abc/form',
    path: '/curva-abc/form',
    getParentRoute: () => AuthenticatedRelatorioRouteRoute,
  } as any)
const AuthenticatedConfiguracaoModelosEtiquetaFormRoute =
  AuthenticatedConfiguracaoModelosEtiquetaFormRouteImport.update({
    id: '/modelos-etiqueta/form',
    path: '/modelos-etiqueta/form',
    getParentRoute: () => AuthenticatedConfiguracaoRouteRoute,
  } as any)
const AuthenticatedConfiguracaoModelosEtiquetaFormIndexRoute =
  AuthenticatedConfiguracaoModelosEtiquetaFormIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedConfiguracaoModelosEtiquetaFormRoute,
  } as any)
const AuthenticatedConfiguracaoModelosEtiquetaFormIdRoute =
  AuthenticatedConfiguracaoModelosEtiquetaFormIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedConfiguracaoModelosEtiquetaFormRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/configuracao': typeof AuthenticatedConfiguracaoRouteRouteWithChildren
  '/consulta': typeof AuthenticatedConsultaRouteRouteWithChildren
  '/estoque': typeof AuthenticatedEstoqueRouteRouteWithChildren
  '/movimentacao': typeof AuthenticatedMovimentacaoRouteRouteWithChildren
  '/relatorio': typeof AuthenticatedRelatorioRouteRouteWithChildren
  '/login/': typeof LoginIndexRoute
  '/home/': typeof AuthenticatedHomeIndexRoute
  '/configuracao/modelos-etiqueta/form': typeof AuthenticatedConfiguracaoModelosEtiquetaFormRouteWithChildren
  '/relatorio/curva-abc/form': typeof AuthenticatedRelatorioCurvaAbcFormRoute
  '/relatorio/etiquetas/form': typeof AuthenticatedRelatorioEtiquetasFormRoute
  '/relatorio/giro-estoque/form': typeof AuthenticatedRelatorioGiroEstoqueFormRoute
  '/relatorio/mapa-producao-expedicao/form': typeof AuthenticatedRelatorioMapaProducaoExpedicaoFormRoute
  '/configuracao/catalogo-produto/': typeof AuthenticatedConfiguracaoCatalogoProdutoIndexRoute
  '/configuracao/config-balanca/': typeof AuthenticatedConfiguracaoConfigBalancaIndexRoute
  '/configuracao/estoque-fisico/': typeof AuthenticatedConfiguracaoEstoqueFisicoIndexRoute
  '/configuracao/impressoras/': typeof AuthenticatedConfiguracaoImpressorasIndexRoute
  '/configuracao/integracoes/': typeof AuthenticatedConfiguracaoIntegracoesIndexRoute
  '/configuracao/modelos-barcode/': typeof AuthenticatedConfiguracaoModelosBarcodeIndexRoute
  '/configuracao/modelos-etiqueta/': typeof AuthenticatedConfiguracaoModelosEtiquetaIndexRoute
  '/configuracao/produtos/': typeof AuthenticatedConfiguracaoProdutosIndexRoute
  '/configuracao/varejo/': typeof AuthenticatedConfiguracaoVarejoIndexRoute
  '/consulta/etiquetas/': typeof AuthenticatedConsultaEtiquetasIndexRoute
  '/estoque/controle-estoque/': typeof AuthenticatedEstoqueControleEstoqueIndexRoute
  '/estoque/relatorio-estoque/': typeof AuthenticatedEstoqueRelatorioEstoqueIndexRoute
  '/estoque/visualizacao-estoque/': typeof AuthenticatedEstoqueVisualizacaoEstoqueIndexRoute
  '/movimentacao/coleta-pesos/': typeof AuthenticatedMovimentacaoColetaPesosIndexRoute
  '/movimentacao/conferencia-xml/': typeof AuthenticatedMovimentacaoConferenciaXmlIndexRoute
  '/movimentacao/enderecamento/': typeof AuthenticatedMovimentacaoEnderecamentoIndexRoute
  '/movimentacao/entrada-produto/': typeof AuthenticatedMovimentacaoEntradaProdutoIndexRoute
  '/movimentacao/leitura-pedido/': typeof AuthenticatedMovimentacaoLeituraPedidoIndexRoute
  '/relatorio/curva-abc/': typeof AuthenticatedRelatorioCurvaAbcIndexRoute
  '/relatorio/etiquetas/': typeof AuthenticatedRelatorioEtiquetasIndexRoute
  '/relatorio/giro-estoque/': typeof AuthenticatedRelatorioGiroEstoqueIndexRoute
  '/relatorio/historicos-integracao/': typeof AuthenticatedRelatorioHistoricosIntegracaoIndexRoute
  '/relatorio/mapa-producao-expedicao/': typeof AuthenticatedRelatorioMapaProducaoExpedicaoIndexRoute
  '/configuracao/modelos-etiqueta/form/$id': typeof AuthenticatedConfiguracaoModelosEtiquetaFormIdRoute
  '/configuracao/modelos-etiqueta/form/': typeof AuthenticatedConfiguracaoModelosEtiquetaFormIndexRoute
}
export interface FileRoutesByTo {
  '/configuracao': typeof AuthenticatedConfiguracaoRouteRouteWithChildren
  '/consulta': typeof AuthenticatedConsultaRouteRouteWithChildren
  '/estoque': typeof AuthenticatedEstoqueRouteRouteWithChildren
  '/movimentacao': typeof AuthenticatedMovimentacaoRouteRouteWithChildren
  '/relatorio': typeof AuthenticatedRelatorioRouteRouteWithChildren
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginIndexRoute
  '/home': typeof AuthenticatedHomeIndexRoute
  '/relatorio/curva-abc/form': typeof AuthenticatedRelatorioCurvaAbcFormRoute
  '/relatorio/etiquetas/form': typeof AuthenticatedRelatorioEtiquetasFormRoute
  '/relatorio/giro-estoque/form': typeof AuthenticatedRelatorioGiroEstoqueFormRoute
  '/relatorio/mapa-producao-expedicao/form': typeof AuthenticatedRelatorioMapaProducaoExpedicaoFormRoute
  '/configuracao/catalogo-produto': typeof AuthenticatedConfiguracaoCatalogoProdutoIndexRoute
  '/configuracao/config-balanca': typeof AuthenticatedConfiguracaoConfigBalancaIndexRoute
  '/configuracao/estoque-fisico': typeof AuthenticatedConfiguracaoEstoqueFisicoIndexRoute
  '/configuracao/impressoras': typeof AuthenticatedConfiguracaoImpressorasIndexRoute
  '/configuracao/integracoes': typeof AuthenticatedConfiguracaoIntegracoesIndexRoute
  '/configuracao/modelos-barcode': typeof AuthenticatedConfiguracaoModelosBarcodeIndexRoute
  '/configuracao/modelos-etiqueta': typeof AuthenticatedConfiguracaoModelosEtiquetaIndexRoute
  '/configuracao/produtos': typeof AuthenticatedConfiguracaoProdutosIndexRoute
  '/configuracao/varejo': typeof AuthenticatedConfiguracaoVarejoIndexRoute
  '/consulta/etiquetas': typeof AuthenticatedConsultaEtiquetasIndexRoute
  '/estoque/controle-estoque': typeof AuthenticatedEstoqueControleEstoqueIndexRoute
  '/estoque/relatorio-estoque': typeof AuthenticatedEstoqueRelatorioEstoqueIndexRoute
  '/estoque/visualizacao-estoque': typeof AuthenticatedEstoqueVisualizacaoEstoqueIndexRoute
  '/movimentacao/coleta-pesos': typeof AuthenticatedMovimentacaoColetaPesosIndexRoute
  '/movimentacao/conferencia-xml': typeof AuthenticatedMovimentacaoConferenciaXmlIndexRoute
  '/movimentacao/enderecamento': typeof AuthenticatedMovimentacaoEnderecamentoIndexRoute
  '/movimentacao/entrada-produto': typeof AuthenticatedMovimentacaoEntradaProdutoIndexRoute
  '/movimentacao/leitura-pedido': typeof AuthenticatedMovimentacaoLeituraPedidoIndexRoute
  '/relatorio/curva-abc': typeof AuthenticatedRelatorioCurvaAbcIndexRoute
  '/relatorio/etiquetas': typeof AuthenticatedRelatorioEtiquetasIndexRoute
  '/relatorio/giro-estoque': typeof AuthenticatedRelatorioGiroEstoqueIndexRoute
  '/relatorio/historicos-integracao': typeof AuthenticatedRelatorioHistoricosIntegracaoIndexRoute
  '/relatorio/mapa-producao-expedicao': typeof AuthenticatedRelatorioMapaProducaoExpedicaoIndexRoute
  '/configuracao/modelos-etiqueta/form/$id': typeof AuthenticatedConfiguracaoModelosEtiquetaFormIdRoute
  '/configuracao/modelos-etiqueta/form': typeof AuthenticatedConfiguracaoModelosEtiquetaFormIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/configuracao': typeof AuthenticatedConfiguracaoRouteRouteWithChildren
  '/_authenticated/consulta': typeof AuthenticatedConsultaRouteRouteWithChildren
  '/_authenticated/estoque': typeof AuthenticatedEstoqueRouteRouteWithChildren
  '/_authenticated/movimentacao': typeof AuthenticatedMovimentacaoRouteRouteWithChildren
  '/_authenticated/relatorio': typeof AuthenticatedRelatorioRouteRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_authenticated/home/': typeof AuthenticatedHomeIndexRoute
  '/_authenticated/configuracao/modelos-etiqueta/form': typeof AuthenticatedConfiguracaoModelosEtiquetaFormRouteWithChildren
  '/_authenticated/relatorio/curva-abc/form': typeof AuthenticatedRelatorioCurvaAbcFormRoute
  '/_authenticated/relatorio/etiquetas/form': typeof AuthenticatedRelatorioEtiquetasFormRoute
  '/_authenticated/relatorio/giro-estoque/form': typeof AuthenticatedRelatorioGiroEstoqueFormRoute
  '/_authenticated/relatorio/mapa-producao-expedicao/form': typeof AuthenticatedRelatorioMapaProducaoExpedicaoFormRoute
  '/_authenticated/configuracao/catalogo-produto/': typeof AuthenticatedConfiguracaoCatalogoProdutoIndexRoute
  '/_authenticated/configuracao/config-balanca/': typeof AuthenticatedConfiguracaoConfigBalancaIndexRoute
  '/_authenticated/configuracao/estoque-fisico/': typeof AuthenticatedConfiguracaoEstoqueFisicoIndexRoute
  '/_authenticated/configuracao/impressoras/': typeof AuthenticatedConfiguracaoImpressorasIndexRoute
  '/_authenticated/configuracao/integracoes/': typeof AuthenticatedConfiguracaoIntegracoesIndexRoute
  '/_authenticated/configuracao/modelos-barcode/': typeof AuthenticatedConfiguracaoModelosBarcodeIndexRoute
  '/_authenticated/configuracao/modelos-etiqueta/': typeof AuthenticatedConfiguracaoModelosEtiquetaIndexRoute
  '/_authenticated/configuracao/produtos/': typeof AuthenticatedConfiguracaoProdutosIndexRoute
  '/_authenticated/configuracao/varejo/': typeof AuthenticatedConfiguracaoVarejoIndexRoute
  '/_authenticated/consulta/etiquetas/': typeof AuthenticatedConsultaEtiquetasIndexRoute
  '/_authenticated/estoque/controle-estoque/': typeof AuthenticatedEstoqueControleEstoqueIndexRoute
  '/_authenticated/estoque/relatorio-estoque/': typeof AuthenticatedEstoqueRelatorioEstoqueIndexRoute
  '/_authenticated/estoque/visualizacao-estoque/': typeof AuthenticatedEstoqueVisualizacaoEstoqueIndexRoute
  '/_authenticated/movimentacao/coleta-pesos/': typeof AuthenticatedMovimentacaoColetaPesosIndexRoute
  '/_authenticated/movimentacao/conferencia-xml/': typeof AuthenticatedMovimentacaoConferenciaXmlIndexRoute
  '/_authenticated/movimentacao/enderecamento/': typeof AuthenticatedMovimentacaoEnderecamentoIndexRoute
  '/_authenticated/movimentacao/entrada-produto/': typeof AuthenticatedMovimentacaoEntradaProdutoIndexRoute
  '/_authenticated/movimentacao/leitura-pedido/': typeof AuthenticatedMovimentacaoLeituraPedidoIndexRoute
  '/_authenticated/relatorio/curva-abc/': typeof AuthenticatedRelatorioCurvaAbcIndexRoute
  '/_authenticated/relatorio/etiquetas/': typeof AuthenticatedRelatorioEtiquetasIndexRoute
  '/_authenticated/relatorio/giro-estoque/': typeof AuthenticatedRelatorioGiroEstoqueIndexRoute
  '/_authenticated/relatorio/historicos-integracao/': typeof AuthenticatedRelatorioHistoricosIntegracaoIndexRoute
  '/_authenticated/relatorio/mapa-producao-expedicao/': typeof AuthenticatedRelatorioMapaProducaoExpedicaoIndexRoute
  '/_authenticated/configuracao/modelos-etiqueta/form/$id': typeof AuthenticatedConfiguracaoModelosEtiquetaFormIdRoute
  '/_authenticated/configuracao/modelos-etiqueta/form/': typeof AuthenticatedConfiguracaoModelosEtiquetaFormIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/configuracao'
    | '/consulta'
    | '/estoque'
    | '/movimentacao'
    | '/relatorio'
    | '/login/'
    | '/home/'
    | '/configuracao/modelos-etiqueta/form'
    | '/relatorio/curva-abc/form'
    | '/relatorio/etiquetas/form'
    | '/relatorio/giro-estoque/form'
    | '/relatorio/mapa-producao-expedicao/form'
    | '/configuracao/catalogo-produto/'
    | '/configuracao/config-balanca/'
    | '/configuracao/estoque-fisico/'
    | '/configuracao/impressoras/'
    | '/configuracao/integracoes/'
    | '/configuracao/modelos-barcode/'
    | '/configuracao/modelos-etiqueta/'
    | '/configuracao/produtos/'
    | '/configuracao/varejo/'
    | '/consulta/etiquetas/'
    | '/estoque/controle-estoque/'
    | '/estoque/relatorio-estoque/'
    | '/estoque/visualizacao-estoque/'
    | '/movimentacao/coleta-pesos/'
    | '/movimentacao/conferencia-xml/'
    | '/movimentacao/enderecamento/'
    | '/movimentacao/entrada-produto/'
    | '/movimentacao/leitura-pedido/'
    | '/relatorio/curva-abc/'
    | '/relatorio/etiquetas/'
    | '/relatorio/giro-estoque/'
    | '/relatorio/historicos-integracao/'
    | '/relatorio/mapa-producao-expedicao/'
    | '/configuracao/modelos-etiqueta/form/$id'
    | '/configuracao/modelos-etiqueta/form/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/configuracao'
    | '/consulta'
    | '/estoque'
    | '/movimentacao'
    | '/relatorio'
    | '/'
    | '/login'
    | '/home'
    | '/relatorio/curva-abc/form'
    | '/relatorio/etiquetas/form'
    | '/relatorio/giro-estoque/form'
    | '/relatorio/mapa-producao-expedicao/form'
    | '/configuracao/catalogo-produto'
    | '/configuracao/config-balanca'
    | '/configuracao/estoque-fisico'
    | '/configuracao/impressoras'
    | '/configuracao/integracoes'
    | '/configuracao/modelos-barcode'
    | '/configuracao/modelos-etiqueta'
    | '/configuracao/produtos'
    | '/configuracao/varejo'
    | '/consulta/etiquetas'
    | '/estoque/controle-estoque'
    | '/estoque/relatorio-estoque'
    | '/estoque/visualizacao-estoque'
    | '/movimentacao/coleta-pesos'
    | '/movimentacao/conferencia-xml'
    | '/movimentacao/enderecamento'
    | '/movimentacao/entrada-produto'
    | '/movimentacao/leitura-pedido'
    | '/relatorio/curva-abc'
    | '/relatorio/etiquetas'
    | '/relatorio/giro-estoque'
    | '/relatorio/historicos-integracao'
    | '/relatorio/mapa-producao-expedicao'
    | '/configuracao/modelos-etiqueta/form/$id'
    | '/configuracao/modelos-etiqueta/form'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/configuracao'
    | '/_authenticated/consulta'
    | '/_authenticated/estoque'
    | '/_authenticated/movimentacao'
    | '/_authenticated/relatorio'
    | '/_authenticated/'
    | '/login/'
    | '/_authenticated/home/'
    | '/_authenticated/configuracao/modelos-etiqueta/form'
    | '/_authenticated/relatorio/curva-abc/form'
    | '/_authenticated/relatorio/etiquetas/form'
    | '/_authenticated/relatorio/giro-estoque/form'
    | '/_authenticated/relatorio/mapa-producao-expedicao/form'
    | '/_authenticated/configuracao/catalogo-produto/'
    | '/_authenticated/configuracao/config-balanca/'
    | '/_authenticated/configuracao/estoque-fisico/'
    | '/_authenticated/configuracao/impressoras/'
    | '/_authenticated/configuracao/integracoes/'
    | '/_authenticated/configuracao/modelos-barcode/'
    | '/_authenticated/configuracao/modelos-etiqueta/'
    | '/_authenticated/configuracao/produtos/'
    | '/_authenticated/configuracao/varejo/'
    | '/_authenticated/consulta/etiquetas/'
    | '/_authenticated/estoque/controle-estoque/'
    | '/_authenticated/estoque/relatorio-estoque/'
    | '/_authenticated/estoque/visualizacao-estoque/'
    | '/_authenticated/movimentacao/coleta-pesos/'
    | '/_authenticated/movimentacao/conferencia-xml/'
    | '/_authenticated/movimentacao/enderecamento/'
    | '/_authenticated/movimentacao/entrada-produto/'
    | '/_authenticated/movimentacao/leitura-pedido/'
    | '/_authenticated/relatorio/curva-abc/'
    | '/_authenticated/relatorio/etiquetas/'
    | '/_authenticated/relatorio/giro-estoque/'
    | '/_authenticated/relatorio/historicos-integracao/'
    | '/_authenticated/relatorio/mapa-producao-expedicao/'
    | '/_authenticated/configuracao/modelos-etiqueta/form/$id'
    | '/_authenticated/configuracao/modelos-etiqueta/form/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/relatorio': {
      id: '/_authenticated/relatorio'
      path: '/relatorio'
      fullPath: '/relatorio'
      preLoaderRoute: typeof AuthenticatedRelatorioRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/movimentacao': {
      id: '/_authenticated/movimentacao'
      path: '/movimentacao'
      fullPath: '/movimentacao'
      preLoaderRoute: typeof AuthenticatedMovimentacaoRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/estoque': {
      id: '/_authenticated/estoque'
      path: '/estoque'
      fullPath: '/estoque'
      preLoaderRoute: typeof AuthenticatedEstoqueRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/consulta': {
      id: '/_authenticated/consulta'
      path: '/consulta'
      fullPath: '/consulta'
      preLoaderRoute: typeof AuthenticatedConsultaRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/configuracao': {
      id: '/_authenticated/configuracao'
      path: '/configuracao'
      fullPath: '/configuracao'
      preLoaderRoute: typeof AuthenticatedConfiguracaoRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home/': {
      id: '/_authenticated/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof AuthenticatedHomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/relatorio/mapa-producao-expedicao/': {
      id: '/_authenticated/relatorio/mapa-producao-expedicao/'
      path: '/mapa-producao-expedicao'
      fullPath: '/relatorio/mapa-producao-expedicao/'
      preLoaderRoute: typeof AuthenticatedRelatorioMapaProducaoExpedicaoIndexRouteImport
      parentRoute: typeof AuthenticatedRelatorioRouteRoute
    }
    '/_authenticated/relatorio/historicos-integracao/': {
      id: '/_authenticated/relatorio/historicos-integracao/'
      path: '/historicos-integracao'
      fullPath: '/relatorio/historicos-integracao/'
      preLoaderRoute: typeof AuthenticatedRelatorioHistoricosIntegracaoIndexRouteImport
      parentRoute: typeof AuthenticatedRelatorioRouteRoute
    }
    '/_authenticated/relatorio/giro-estoque/': {
      id: '/_authenticated/relatorio/giro-estoque/'
      path: '/giro-estoque'
      fullPath: '/relatorio/giro-estoque/'
      preLoaderRoute: typeof AuthenticatedRelatorioGiroEstoqueIndexRouteImport
      parentRoute: typeof AuthenticatedRelatorioRouteRoute
    }
    '/_authenticated/relatorio/etiquetas/': {
      id: '/_authenticated/relatorio/etiquetas/'
      path: '/etiquetas'
      fullPath: '/relatorio/etiquetas/'
      preLoaderRoute: typeof AuthenticatedRelatorioEtiquetasIndexRouteImport
      parentRoute: typeof AuthenticatedRelatorioRouteRoute
    }
    '/_authenticated/relatorio/curva-abc/': {
      id: '/_authenticated/relatorio/curva-abc/'
      path: '/curva-abc'
      fullPath: '/relatorio/curva-abc/'
      preLoaderRoute: typeof AuthenticatedRelatorioCurvaAbcIndexRouteImport
      parentRoute: typeof AuthenticatedRelatorioRouteRoute
    }
    '/_authenticated/movimentacao/leitura-pedido/': {
      id: '/_authenticated/movimentacao/leitura-pedido/'
      path: '/leitura-pedido'
      fullPath: '/movimentacao/leitura-pedido/'
      preLoaderRoute: typeof AuthenticatedMovimentacaoLeituraPedidoIndexRouteImport
      parentRoute: typeof AuthenticatedMovimentacaoRouteRoute
    }
    '/_authenticated/movimentacao/entrada-produto/': {
      id: '/_authenticated/movimentacao/entrada-produto/'
      path: '/entrada-produto'
      fullPath: '/movimentacao/entrada-produto/'
      preLoaderRoute: typeof AuthenticatedMovimentacaoEntradaProdutoIndexRouteImport
      parentRoute: typeof AuthenticatedMovimentacaoRouteRoute
    }
    '/_authenticated/movimentacao/enderecamento/': {
      id: '/_authenticated/movimentacao/enderecamento/'
      path: '/enderecamento'
      fullPath: '/movimentacao/enderecamento/'
      preLoaderRoute: typeof AuthenticatedMovimentacaoEnderecamentoIndexRouteImport
      parentRoute: typeof AuthenticatedMovimentacaoRouteRoute
    }
    '/_authenticated/movimentacao/conferencia-xml/': {
      id: '/_authenticated/movimentacao/conferencia-xml/'
      path: '/conferencia-xml'
      fullPath: '/movimentacao/conferencia-xml/'
      preLoaderRoute: typeof AuthenticatedMovimentacaoConferenciaXmlIndexRouteImport
      parentRoute: typeof AuthenticatedMovimentacaoRouteRoute
    }
    '/_authenticated/movimentacao/coleta-pesos/': {
      id: '/_authenticated/movimentacao/coleta-pesos/'
      path: '/coleta-pesos'
      fullPath: '/movimentacao/coleta-pesos/'
      preLoaderRoute: typeof AuthenticatedMovimentacaoColetaPesosIndexRouteImport
      parentRoute: typeof AuthenticatedMovimentacaoRouteRoute
    }
    '/_authenticated/estoque/visualizacao-estoque/': {
      id: '/_authenticated/estoque/visualizacao-estoque/'
      path: '/visualizacao-estoque'
      fullPath: '/estoque/visualizacao-estoque/'
      preLoaderRoute: typeof AuthenticatedEstoqueVisualizacaoEstoqueIndexRouteImport
      parentRoute: typeof AuthenticatedEstoqueRouteRoute
    }
    '/_authenticated/estoque/relatorio-estoque/': {
      id: '/_authenticated/estoque/relatorio-estoque/'
      path: '/relatorio-estoque'
      fullPath: '/estoque/relatorio-estoque/'
      preLoaderRoute: typeof AuthenticatedEstoqueRelatorioEstoqueIndexRouteImport
      parentRoute: typeof AuthenticatedEstoqueRouteRoute
    }
    '/_authenticated/estoque/controle-estoque/': {
      id: '/_authenticated/estoque/controle-estoque/'
      path: '/controle-estoque'
      fullPath: '/estoque/controle-estoque/'
      preLoaderRoute: typeof AuthenticatedEstoqueControleEstoqueIndexRouteImport
      parentRoute: typeof AuthenticatedEstoqueRouteRoute
    }
    '/_authenticated/consulta/etiquetas/': {
      id: '/_authenticated/consulta/etiquetas/'
      path: '/etiquetas'
      fullPath: '/consulta/etiquetas/'
      preLoaderRoute: typeof AuthenticatedConsultaEtiquetasIndexRouteImport
      parentRoute: typeof AuthenticatedConsultaRouteRoute
    }
    '/_authenticated/configuracao/varejo/': {
      id: '/_authenticated/configuracao/varejo/'
      path: '/varejo'
      fullPath: '/configuracao/varejo/'
      preLoaderRoute: typeof AuthenticatedConfiguracaoVarejoIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoRouteRoute
    }
    '/_authenticated/configuracao/produtos/': {
      id: '/_authenticated/configuracao/produtos/'
      path: '/produtos'
      fullPath: '/configuracao/produtos/'
      preLoaderRoute: typeof AuthenticatedConfiguracaoProdutosIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoRouteRoute
    }
    '/_authenticated/configuracao/modelos-etiqueta/': {
      id: '/_authenticated/configuracao/modelos-etiqueta/'
      path: '/modelos-etiqueta'
      fullPath: '/configuracao/modelos-etiqueta/'
      preLoaderRoute: typeof AuthenticatedConfiguracaoModelosEtiquetaIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoRouteRoute
    }
    '/_authenticated/configuracao/modelos-barcode/': {
      id: '/_authenticated/configuracao/modelos-barcode/'
      path: '/modelos-barcode'
      fullPath: '/configuracao/modelos-barcode/'
      preLoaderRoute: typeof AuthenticatedConfiguracaoModelosBarcodeIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoRouteRoute
    }
    '/_authenticated/configuracao/integracoes/': {
      id: '/_authenticated/configuracao/integracoes/'
      path: '/integracoes'
      fullPath: '/configuracao/integracoes/'
      preLoaderRoute: typeof AuthenticatedConfiguracaoIntegracoesIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoRouteRoute
    }
    '/_authenticated/configuracao/impressoras/': {
      id: '/_authenticated/configuracao/impressoras/'
      path: '/impressoras'
      fullPath: '/configuracao/impressoras/'
      preLoaderRoute: typeof AuthenticatedConfiguracaoImpressorasIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoRouteRoute
    }
    '/_authenticated/configuracao/estoque-fisico/': {
      id: '/_authenticated/configuracao/estoque-fisico/'
      path: '/estoque-fisico'
      fullPath: '/configuracao/estoque-fisico/'
      preLoaderRoute: typeof AuthenticatedConfiguracaoEstoqueFisicoIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoRouteRoute
    }
    '/_authenticated/configuracao/config-balanca/': {
      id: '/_authenticated/configuracao/config-balanca/'
      path: '/config-balanca'
      fullPath: '/configuracao/config-balanca/'
      preLoaderRoute: typeof AuthenticatedConfiguracaoConfigBalancaIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoRouteRoute
    }
    '/_authenticated/configuracao/catalogo-produto/': {
      id: '/_authenticated/configuracao/catalogo-produto/'
      path: '/catalogo-produto'
      fullPath: '/configuracao/catalogo-produto/'
      preLoaderRoute: typeof AuthenticatedConfiguracaoCatalogoProdutoIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoRouteRoute
    }
    '/_authenticated/relatorio/mapa-producao-expedicao/form': {
      id: '/_authenticated/relatorio/mapa-producao-expedicao/form'
      path: '/mapa-producao-expedicao/form'
      fullPath: '/relatorio/mapa-producao-expedicao/form'
      preLoaderRoute: typeof AuthenticatedRelatorioMapaProducaoExpedicaoFormRouteImport
      parentRoute: typeof AuthenticatedRelatorioRouteRoute
    }
    '/_authenticated/relatorio/giro-estoque/form': {
      id: '/_authenticated/relatorio/giro-estoque/form'
      path: '/giro-estoque/form'
      fullPath: '/relatorio/giro-estoque/form'
      preLoaderRoute: typeof AuthenticatedRelatorioGiroEstoqueFormRouteImport
      parentRoute: typeof AuthenticatedRelatorioRouteRoute
    }
    '/_authenticated/relatorio/etiquetas/form': {
      id: '/_authenticated/relatorio/etiquetas/form'
      path: '/etiquetas/form'
      fullPath: '/relatorio/etiquetas/form'
      preLoaderRoute: typeof AuthenticatedRelatorioEtiquetasFormRouteImport
      parentRoute: typeof AuthenticatedRelatorioRouteRoute
    }
    '/_authenticated/relatorio/curva-abc/form': {
      id: '/_authenticated/relatorio/curva-abc/form'
      path: '/curva-abc/form'
      fullPath: '/relatorio/curva-abc/form'
      preLoaderRoute: typeof AuthenticatedRelatorioCurvaAbcFormRouteImport
      parentRoute: typeof AuthenticatedRelatorioRouteRoute
    }
    '/_authenticated/configuracao/modelos-etiqueta/form': {
      id: '/_authenticated/configuracao/modelos-etiqueta/form'
      path: '/modelos-etiqueta/form'
      fullPath: '/configuracao/modelos-etiqueta/form'
      preLoaderRoute: typeof AuthenticatedConfiguracaoModelosEtiquetaFormRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoRouteRoute
    }
    '/_authenticated/configuracao/modelos-etiqueta/form/': {
      id: '/_authenticated/configuracao/modelos-etiqueta/form/'
      path: '/'
      fullPath: '/configuracao/modelos-etiqueta/form/'
      preLoaderRoute: typeof AuthenticatedConfiguracaoModelosEtiquetaFormIndexRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoModelosEtiquetaFormRoute
    }
    '/_authenticated/configuracao/modelos-etiqueta/form/$id': {
      id: '/_authenticated/configuracao/modelos-etiqueta/form/$id'
      path: '/$id'
      fullPath: '/configuracao/modelos-etiqueta/form/$id'
      preLoaderRoute: typeof AuthenticatedConfiguracaoModelosEtiquetaFormIdRouteImport
      parentRoute: typeof AuthenticatedConfiguracaoModelosEtiquetaFormRoute
    }
  }
}

interface AuthenticatedConfiguracaoModelosEtiquetaFormRouteChildren {
  AuthenticatedConfiguracaoModelosEtiquetaFormIdRoute: typeof AuthenticatedConfiguracaoModelosEtiquetaFormIdRoute
  AuthenticatedConfiguracaoModelosEtiquetaFormIndexRoute: typeof AuthenticatedConfiguracaoModelosEtiquetaFormIndexRoute
}

const AuthenticatedConfiguracaoModelosEtiquetaFormRouteChildren: AuthenticatedConfiguracaoModelosEtiquetaFormRouteChildren =
  {
    AuthenticatedConfiguracaoModelosEtiquetaFormIdRoute:
      AuthenticatedConfiguracaoModelosEtiquetaFormIdRoute,
    AuthenticatedConfiguracaoModelosEtiquetaFormIndexRoute:
      AuthenticatedConfiguracaoModelosEtiquetaFormIndexRoute,
  }

const AuthenticatedConfiguracaoModelosEtiquetaFormRouteWithChildren =
  AuthenticatedConfiguracaoModelosEtiquetaFormRoute._addFileChildren(
    AuthenticatedConfiguracaoModelosEtiquetaFormRouteChildren,
  )

interface AuthenticatedConfiguracaoRouteRouteChildren {
  AuthenticatedConfiguracaoModelosEtiquetaFormRoute: typeof AuthenticatedConfiguracaoModelosEtiquetaFormRouteWithChildren
  AuthenticatedConfiguracaoCatalogoProdutoIndexRoute: typeof AuthenticatedConfiguracaoCatalogoProdutoIndexRoute
  AuthenticatedConfiguracaoConfigBalancaIndexRoute: typeof AuthenticatedConfiguracaoConfigBalancaIndexRoute
  AuthenticatedConfiguracaoEstoqueFisicoIndexRoute: typeof AuthenticatedConfiguracaoEstoqueFisicoIndexRoute
  AuthenticatedConfiguracaoImpressorasIndexRoute: typeof AuthenticatedConfiguracaoImpressorasIndexRoute
  AuthenticatedConfiguracaoIntegracoesIndexRoute: typeof AuthenticatedConfiguracaoIntegracoesIndexRoute
  AuthenticatedConfiguracaoModelosBarcodeIndexRoute: typeof AuthenticatedConfiguracaoModelosBarcodeIndexRoute
  AuthenticatedConfiguracaoModelosEtiquetaIndexRoute: typeof AuthenticatedConfiguracaoModelosEtiquetaIndexRoute
  AuthenticatedConfiguracaoProdutosIndexRoute: typeof AuthenticatedConfiguracaoProdutosIndexRoute
  AuthenticatedConfiguracaoVarejoIndexRoute: typeof AuthenticatedConfiguracaoVarejoIndexRoute
}

const AuthenticatedConfiguracaoRouteRouteChildren: AuthenticatedConfiguracaoRouteRouteChildren =
  {
    AuthenticatedConfiguracaoModelosEtiquetaFormRoute:
      AuthenticatedConfiguracaoModelosEtiquetaFormRouteWithChildren,
    AuthenticatedConfiguracaoCatalogoProdutoIndexRoute:
      AuthenticatedConfiguracaoCatalogoProdutoIndexRoute,
    AuthenticatedConfiguracaoConfigBalancaIndexRoute:
      AuthenticatedConfiguracaoConfigBalancaIndexRoute,
    AuthenticatedConfiguracaoEstoqueFisicoIndexRoute:
      AuthenticatedConfiguracaoEstoqueFisicoIndexRoute,
    AuthenticatedConfiguracaoImpressorasIndexRoute:
      AuthenticatedConfiguracaoImpressorasIndexRoute,
    AuthenticatedConfiguracaoIntegracoesIndexRoute:
      AuthenticatedConfiguracaoIntegracoesIndexRoute,
    AuthenticatedConfiguracaoModelosBarcodeIndexRoute:
      AuthenticatedConfiguracaoModelosBarcodeIndexRoute,
    AuthenticatedConfiguracaoModelosEtiquetaIndexRoute:
      AuthenticatedConfiguracaoModelosEtiquetaIndexRoute,
    AuthenticatedConfiguracaoProdutosIndexRoute:
      AuthenticatedConfiguracaoProdutosIndexRoute,
    AuthenticatedConfiguracaoVarejoIndexRoute:
      AuthenticatedConfiguracaoVarejoIndexRoute,
  }

const AuthenticatedConfiguracaoRouteRouteWithChildren =
  AuthenticatedConfiguracaoRouteRoute._addFileChildren(
    AuthenticatedConfiguracaoRouteRouteChildren,
  )

interface AuthenticatedConsultaRouteRouteChildren {
  AuthenticatedConsultaEtiquetasIndexRoute: typeof AuthenticatedConsultaEtiquetasIndexRoute
}

const AuthenticatedConsultaRouteRouteChildren: AuthenticatedConsultaRouteRouteChildren =
  {
    AuthenticatedConsultaEtiquetasIndexRoute:
      AuthenticatedConsultaEtiquetasIndexRoute,
  }

const AuthenticatedConsultaRouteRouteWithChildren =
  AuthenticatedConsultaRouteRoute._addFileChildren(
    AuthenticatedConsultaRouteRouteChildren,
  )

interface AuthenticatedEstoqueRouteRouteChildren {
  AuthenticatedEstoqueControleEstoqueIndexRoute: typeof AuthenticatedEstoqueControleEstoqueIndexRoute
  AuthenticatedEstoqueRelatorioEstoqueIndexRoute: typeof AuthenticatedEstoqueRelatorioEstoqueIndexRoute
  AuthenticatedEstoqueVisualizacaoEstoqueIndexRoute: typeof AuthenticatedEstoqueVisualizacaoEstoqueIndexRoute
}

const AuthenticatedEstoqueRouteRouteChildren: AuthenticatedEstoqueRouteRouteChildren =
  {
    AuthenticatedEstoqueControleEstoqueIndexRoute:
      AuthenticatedEstoqueControleEstoqueIndexRoute,
    AuthenticatedEstoqueRelatorioEstoqueIndexRoute:
      AuthenticatedEstoqueRelatorioEstoqueIndexRoute,
    AuthenticatedEstoqueVisualizacaoEstoqueIndexRoute:
      AuthenticatedEstoqueVisualizacaoEstoqueIndexRoute,
  }

const AuthenticatedEstoqueRouteRouteWithChildren =
  AuthenticatedEstoqueRouteRoute._addFileChildren(
    AuthenticatedEstoqueRouteRouteChildren,
  )

interface AuthenticatedMovimentacaoRouteRouteChildren {
  AuthenticatedMovimentacaoColetaPesosIndexRoute: typeof AuthenticatedMovimentacaoColetaPesosIndexRoute
  AuthenticatedMovimentacaoConferenciaXmlIndexRoute: typeof AuthenticatedMovimentacaoConferenciaXmlIndexRoute
  AuthenticatedMovimentacaoEnderecamentoIndexRoute: typeof AuthenticatedMovimentacaoEnderecamentoIndexRoute
  AuthenticatedMovimentacaoEntradaProdutoIndexRoute: typeof AuthenticatedMovimentacaoEntradaProdutoIndexRoute
  AuthenticatedMovimentacaoLeituraPedidoIndexRoute: typeof AuthenticatedMovimentacaoLeituraPedidoIndexRoute
}

const AuthenticatedMovimentacaoRouteRouteChildren: AuthenticatedMovimentacaoRouteRouteChildren =
  {
    AuthenticatedMovimentacaoColetaPesosIndexRoute:
      AuthenticatedMovimentacaoColetaPesosIndexRoute,
    AuthenticatedMovimentacaoConferenciaXmlIndexRoute:
      AuthenticatedMovimentacaoConferenciaXmlIndexRoute,
    AuthenticatedMovimentacaoEnderecamentoIndexRoute:
      AuthenticatedMovimentacaoEnderecamentoIndexRoute,
    AuthenticatedMovimentacaoEntradaProdutoIndexRoute:
      AuthenticatedMovimentacaoEntradaProdutoIndexRoute,
    AuthenticatedMovimentacaoLeituraPedidoIndexRoute:
      AuthenticatedMovimentacaoLeituraPedidoIndexRoute,
  }

const AuthenticatedMovimentacaoRouteRouteWithChildren =
  AuthenticatedMovimentacaoRouteRoute._addFileChildren(
    AuthenticatedMovimentacaoRouteRouteChildren,
  )

interface AuthenticatedRelatorioRouteRouteChildren {
  AuthenticatedRelatorioCurvaAbcFormRoute: typeof AuthenticatedRelatorioCurvaAbcFormRoute
  AuthenticatedRelatorioEtiquetasFormRoute: typeof AuthenticatedRelatorioEtiquetasFormRoute
  AuthenticatedRelatorioGiroEstoqueFormRoute: typeof AuthenticatedRelatorioGiroEstoqueFormRoute
  AuthenticatedRelatorioMapaProducaoExpedicaoFormRoute: typeof AuthenticatedRelatorioMapaProducaoExpedicaoFormRoute
  AuthenticatedRelatorioCurvaAbcIndexRoute: typeof AuthenticatedRelatorioCurvaAbcIndexRoute
  AuthenticatedRelatorioEtiquetasIndexRoute: typeof AuthenticatedRelatorioEtiquetasIndexRoute
  AuthenticatedRelatorioGiroEstoqueIndexRoute: typeof AuthenticatedRelatorioGiroEstoqueIndexRoute
  AuthenticatedRelatorioHistoricosIntegracaoIndexRoute: typeof AuthenticatedRelatorioHistoricosIntegracaoIndexRoute
  AuthenticatedRelatorioMapaProducaoExpedicaoIndexRoute: typeof AuthenticatedRelatorioMapaProducaoExpedicaoIndexRoute
}

const AuthenticatedRelatorioRouteRouteChildren: AuthenticatedRelatorioRouteRouteChildren =
  {
    AuthenticatedRelatorioCurvaAbcFormRoute:
      AuthenticatedRelatorioCurvaAbcFormRoute,
    AuthenticatedRelatorioEtiquetasFormRoute:
      AuthenticatedRelatorioEtiquetasFormRoute,
    AuthenticatedRelatorioGiroEstoqueFormRoute:
      AuthenticatedRelatorioGiroEstoqueFormRoute,
    AuthenticatedRelatorioMapaProducaoExpedicaoFormRoute:
      AuthenticatedRelatorioMapaProducaoExpedicaoFormRoute,
    AuthenticatedRelatorioCurvaAbcIndexRoute:
      AuthenticatedRelatorioCurvaAbcIndexRoute,
    AuthenticatedRelatorioEtiquetasIndexRoute:
      AuthenticatedRelatorioEtiquetasIndexRoute,
    AuthenticatedRelatorioGiroEstoqueIndexRoute:
      AuthenticatedRelatorioGiroEstoqueIndexRoute,
    AuthenticatedRelatorioHistoricosIntegracaoIndexRoute:
      AuthenticatedRelatorioHistoricosIntegracaoIndexRoute,
    AuthenticatedRelatorioMapaProducaoExpedicaoIndexRoute:
      AuthenticatedRelatorioMapaProducaoExpedicaoIndexRoute,
  }

const AuthenticatedRelatorioRouteRouteWithChildren =
  AuthenticatedRelatorioRouteRoute._addFileChildren(
    AuthenticatedRelatorioRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedConfiguracaoRouteRoute: typeof AuthenticatedConfiguracaoRouteRouteWithChildren
  AuthenticatedConsultaRouteRoute: typeof AuthenticatedConsultaRouteRouteWithChildren
  AuthenticatedEstoqueRouteRoute: typeof AuthenticatedEstoqueRouteRouteWithChildren
  AuthenticatedMovimentacaoRouteRoute: typeof AuthenticatedMovimentacaoRouteRouteWithChildren
  AuthenticatedRelatorioRouteRoute: typeof AuthenticatedRelatorioRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedHomeIndexRoute: typeof AuthenticatedHomeIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedConfiguracaoRouteRoute:
    AuthenticatedConfiguracaoRouteRouteWithChildren,
  AuthenticatedConsultaRouteRoute: AuthenticatedConsultaRouteRouteWithChildren,
  AuthenticatedEstoqueRouteRoute: AuthenticatedEstoqueRouteRouteWithChildren,
  AuthenticatedMovimentacaoRouteRoute:
    AuthenticatedMovimentacaoRouteRouteWithChildren,
  AuthenticatedRelatorioRouteRoute:
    AuthenticatedRelatorioRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedHomeIndexRoute: AuthenticatedHomeIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
